import { faPen, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress, Link, Tooltip } from "@mui/material";
import TextField from "components/Common/TextField/TextField";

type BbgFieldProps = {
    label: string;
    value: string;
    placeholder: string;
    bbgStatus: "idle" | "loading" | "success" | "error";
    isDisabled: boolean;
    onEdit: () => void;
    onChange: (val: string) => void;
    error?: string;
    showRefetch?: boolean;
    onRefetch?: () => void;
};

const BbgField = ({
    label,
    value,
    placeholder,
    bbgStatus,
    isDisabled,
    onEdit,
    onChange,
    error,
    showRefetch,
    onRefetch,
}: BbgFieldProps) => (
    <div>
        <div className="labelWithEdit">
            <label>{label}</label>
            {bbgStatus === "loading" ? (
                <Tooltip title="Fetching data from Bloomberg">
                    <CircularProgress size={12} />
                </Tooltip>
            ) : (
                <>
                    {isDisabled && (
                        <Link
                            component="button"
                            variant="body2"
                            onClick={onEdit}
                            underline="hover"
                            sx={{
                                fontSize: 11,
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPen}
                                style={{ fontSize: 10 }}
                            />
                            Edit
                        </Link>
                    )}
                    {showRefetch && onRefetch && (
                        <Tooltip title="Fetch company details from Bloomberg using current ticker">
                            <Link
                                component="button"
                                variant="body2"
                                onClick={onRefetch}
                                underline="hover"
                                sx={{
                                    fontSize: 11,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    ml: isDisabled ? 1 : 0,
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faSync}
                                    style={{ fontSize: 10 }}
                                />
                                Fetch from BBG
                            </Link>
                        </Tooltip>
                    )}
                </>
            )}
        </div>
        <TextField
            value={value}
            change={onChange}
            placeholder={placeholder}
            error={!!error}
            errorText={error}
            disabled={isDisabled || bbgStatus === "loading"}
        />
    </div>
);

export default BbgField;
